import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { ClientContactDO } from 'app/BaseFramework/shared/models'
import { ErrorDO } from 'app/BaseFramework/shared/models/error.model';

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

@Component({
  selector: 'app-phone-list-details',
  templateUrl: './phone-list-details.component.html',
  styleUrls: ['./phone-list-details.component.scss']
})


export class PhoneListDetailsComponent implements OnInit {

  _currentComponentName = 'PhoneListDetailsComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private notification: NzNotificationService,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private appMetadataHandler: AppMetadataHandler,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService) { }

  //Declaraions which might need developer input
  uiMultirowBasicForm: FormGroup
  UIMULTIROWBASICFORMNAME = "uiMultirowBasicForm"
  lookupsToBind = ['phoneTypeCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$
  isReadOnly : boolean = this.appMetadataHandler.isReadOnly;


  /**
     *
     *  Ninad: Whenever any developer is creating a new Component,
     * please make sure that you copy all import commands, constructor and
     * Boiler and Component Creation Kickstart CODE 
     *
     * 
     * Component Creation Kickstart CODE 
     */

  //ComponentSpecific Inputs, Outputs

  @Input() placeholderVal: string = '';
  searchHasData: boolean = false;
  searchTerm: string = '';
  lookupTypeCd: string = 'phoneTypeCd';
  type: string = 'phone';
  item
  @Output() componentOutput = new EventEmitter<any>();
  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) {

      this._inputDataForEdit = value;
      this.initializeClientSearchForm(this._inputDataForEdit)
      this.ServerToUITransform(this._inputDataForEdit);
    }else{
      this.phoneList = [];
    }

  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput, this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => { 
      let validationResult = this.validateOutput(this.uiMultirowBasicForm)
      if (validationResult.isInvalid) {
        this.EmitComponentOutput(validationResult)
      }
      else {
        let mob = this.uiMultirowBasicForm.value.phone
        if (mob && mob.length == 8) {
          this.addPhoneToList();
        }
        this.EmitComponentOutput(this.phoneList)
      }
    })
  }

  validateOutput(o) {
    if (o) {
      this.commonUtilty.markAllFieldDirty(o);
      // return o.valid();
      let validationOutput: ValidationOutput = {
        isInvalid: null,
        errorDOs: []
      }
      validationOutput.errorDOs = this.checkInvalidAndEmptyFields(o, this.getCurrentComponentName())
  
      if (Array.isArray(validationOutput.errorDOs) && validationOutput.errorDOs.length > 0) {
        validationOutput.isInvalid = true;
      }
      else {
        validationOutput.isInvalid = false;
      }
  
      return validationOutput
    }
  }

  public checkInvalidAndEmptyFields(Form: FormGroup, componentName) {
    let invalidFields = [];
    if (Form && !Form.valid) {
      for (const i in Form.controls) {
        let controlName = this.commonUtilty.getControlName(Form.controls[i])
        // let validationErrorList = this.validationUtilService.getUIErrorList(this.uiMultirowBasicForm.get(controlName), "Contact Details Form")
        if (Form.controls[i].status === 'INVALID') {
          // validationErrorList.forEach(validationError => {
            let errorDO = new ErrorDO();
            errorDO.errorMsg = "Phone number digits is less than the required 8";
            errorDO.validationLevel = null
            errorDO.validationEvent = "save"
            errorDO.validationType = "notEqualTo"
            errorDO.fieldName = controlName;
            errorDO.fieldNameDescription = "Contact Detail Entry"
            errorDO.componentName = componentName;
            invalidFields.push(errorDO)
          // })
        }
      }
    }
    return invalidFields;
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()

  }


  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.uiMultirowBasicForm = this.fb.group({
      typeCd: this.validationUtilService.setValidationsForFormControl('typeCd', this.UIMULTIROWBASICFORMNAME, payload['typeCd']),
      phone: this.validationUtilService.setValidationsForFormControl('phone', this.UIMULTIROWBASICFORMNAME, payload['phone'], null),
      id: this.validationUtilService.setValidationsForFormControl('id', this.UIMULTIROWBASICFORMNAME, payload['id']),
      prefferedFl: this.validationUtilService.setValidationsForFormControl('prefferedFl', this.UIMULTIROWBASICFORMNAME, payload['prefferedFl']),
    });
  }

  isRequired(fieldName, formName?) {
    let nameOfForm = null
    if (formName) {
      nameOfForm = formName
    }
    else {
      nameOfForm = this.UIMULTIROWBASICFORMNAME
    }
    let returnObj = this.validationUtilService.isRequired(fieldName, nameOfForm)
    return returnObj
  }
  phoneList: any = [];
  emailList: any = [];

  addRow() {
    if (this.uiMultirowBasicForm.status === 'VALID') {

      let mob = this.uiMultirowBasicForm.value.phone
      if(mob){
        if (mob.length < 8) {
          this.notification.error('Not Valid', 'Please enter valid mobile number');
        }
        else {
        this.addPhoneToList();
        //this.EmitComponentOutput(this.phoneList)
        }
      }
      this.searchHasData = true;
      this.initializeClientSearchForm()
    }else{
      this.notification.error('Not Valid', 'Please enter valid mobile number');
    }
  }

  removeRow(index) {
    this.phoneList.splice(index, 1)
  }

  addPhoneToList(){
    let clientContactDO = new ClientContactDO();
    clientContactDO.typeCd = this.uiMultirowBasicForm.value.typeCd;
    clientContactDO.contactNum = this.uiMultirowBasicForm.value.phone;
    if (this.phoneList && this.phoneList.length == 0)
      this.uiMultirowBasicForm.value.prefferedFl = true;
    clientContactDO.prefferedFl = this.uiMultirowBasicForm.value.prefferedFl,
      clientContactDO.id = this.uiMultirowBasicForm.value.id;
    this.phoneList =this.commonUtilty.uniquePushInArray(this.phoneList, clientContactDO);
    this.phoneList = this.checkDuplicateEntry(this.phoneList);
  }

  checkDuplicateEntry(phoneList){
    var newArray = [];
    if(this.commonUtilty.isArrayIterable(phoneList)){
      var lookupObject  = {};

      phoneList.forEach(element => {
        if(!lookupObject[element.contactNum+'-'+element.typeCd]){
          lookupObject[element.contactNum+'-'+element.typeCd] = element;
        }
      });

      for(var i in lookupObject) {
        newArray.push(lookupObject[i]);
      }

      return newArray;
    }
    return newArray;
  }

  deselectOtherPhonesPrefferedFl(preIndex) {
    this.phoneList.forEach((element, index) => {
      if (preIndex != index) element.prefferedFl = false
    });
  }

  mobLengthVal = true
  onMobChange(event) {
    let mob = this.uiMultirowBasicForm.get('phone').value;
    if (mob.length < 8)
      this.mobLengthVal = false
  }


  // transform inside component
  UItoServerTransform(payload, response) {
    let DO = this.commonUtilty.getDOName(payload)
    if (payload) {
      payload['providerClientDO']['clientContactDetailsList'] = this.commonUtilty.deepCopy(response.componentData) //deepcopy
    }
    if (this.appMetadataHandler.featureFlags.enableTransformLogForSteps && environment.production) {
      console.log(`UIToServer Transformation ${response.componentName} : ${JSON.stringify(payload)}`)
    }
    return payload
  }

  ServerToUITransform(payload) {
    let DO = this.commonUtilty.getDOName(payload);
    // let output = [];
    if (payload && payload[DO]) {

      if (this.commonUtilty.isArrayIterable(payload['providerClientDO']['clientContactDetailsList'])) {
        this.phoneList = payload['providerClientDO']['clientContactDetailsList']
      }
    }
    // return output;
  }

  onlyDigitsAllowedONPaste(evt){
    let inputValue = evt.clipboardData.getData('Text')
    if(Number.isNaN(Number(inputValue)))
        return false
      else 
      return true
  }
}
